/** API 성공 응답 (단일) */
export interface ApiResponse<T> {
  success: true
  data: T
  message?: string
}

/** API 성공 응답 (페이지네이션 - Spring Page 구조) */
export interface ApiPageResponse<T> {
  success: true
  data: {
    content: T[]
    totalElements: number
    totalPages: number
    number: number
    size: number
    last: boolean
    first: boolean
    empty: boolean
  }
  meta?: {
    page: number
    size: number
    totalElements: number
    totalPages: number
  }
}

/** API 에러 응답 */
export interface ApiErrorResponse {
  success: false
  error: {
    code: string
    message: string
    details?: Record<string, string>
  }
  timestamp: string
}

/** API 에러 */
export class ApiError extends Error {
  public readonly code: string
  public readonly status: number
  public readonly details?: Record<string, string>

  constructor(
    message: string,
    code: string,
    status: number,
    details?: Record<string, string>
  ) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.status = status
    this.details = details
  }
}
